import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import Snackbar from "../snackbar";
import { chartStyle } from "./style";
const emotion = ["love", "happy", "normal", "sad", "angry"];
const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value } = props;
  const radius = 10;
  return (
    <div>45</div>
    // <g>
    //   <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" />
    //   <text x={x + width / 2} y={y - radius} fill="#fff" textAnchor="middle" dominantBaseline="middle">
    //     {value.split('/')[1]}
    //   </text>
    // </g>
  );
};
class SimpleLineChart extends React.Component {
  static jsfiddleUrl = "https://jsfiddle.net/alidingling/a5Leskck/";
  constructor(props) {
    super(props);
    this.state = {
      // data: [
      //     {name: 'May 2018', angry: 1, sad: 2,normal: 1, happy: 3, love: 8},
      //     {name: 'Now 2018', angry: 5, sad: 45,normal: 1, happy: 23, love: 12},
      //     {name: 'Dec 2018', angry: 7, sad: 122,normal: 23, happy: 111, love: 23},
      //     {name: 'Jan 2019', angry: 123, sad: 23,normal: 241, happy: 3, love: 1},
      //     {name: 'Feb 2019', angry: 45, sad: 133,normal: 23, happy: 222, love: 1},
      //     {name: 'Mar 2019', angry: 21, sad: 2,normal: 122, happy: 3, love: 0},
      // ]
    };
  }

  render() {
    let { data, t, classes } = this.props;
    return (
      <div>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <ResponsiveContainer width={"100%"} height={240}>
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            {/* <Legend /> */}
            <Bar dataKey="angry" fill="#dc3545"></Bar>
            <Bar dataKey="sad" fill="#ffc107"></Bar>
            <Bar dataKey="normal" fill="#007bff"></Bar>
            <Bar dataKey="happy" fill="#28a745"></Bar>
            <Bar dataKey="love" fill="#ff11fc">
              <LabelList dataKey="time" content={renderCustomizedLabel} />
            </Bar>
          </BarChart>
          {/* <LineChart data={data} margin={{top: 8, right: 40, left: 8, bottom: 24}}>
              <XAxis dataKey="name" dy={10} />
              <YAxis/>
              <CartesianGrid strokeDasharray="3 3" vertical={false}/>
              <Tooltip/>
              <Line connectNulls={true} type="monotone" dataKey="angry" stroke="#ff6b5c" dot={{fill: '#ff6b5c' }}/>
              <Line connectNulls={true} type="monotone" dataKey="sad" stroke="#380be4" dot={{fill: '#ff6b5c' }}/>
              <Line connectNulls={true} type="monotone" dataKey="normal" stroke="#ff6c5c" dot={{fill: '#ff6b5c' }}/>
              <Line connectNulls={true} type="monotone" dataKey="happy" stroke="#ff1b5c" dot={{fill: '#ff6b5c' }}/>
              <Line connectNulls={true} type="monotone" dataKey="love" stroke="#ff3b5c" dot={{fill: '#ff6b5c' }}/>
            </LineChart> */}
        </ResponsiveContainer>
        <div className={classes.containerNote}>
          {emotion.map((ele, index) => {
            return (
              <div className={classes.note}>
                <div className={classes[ele]}></div>
                <div>{t("nps_" + ele)}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  // npsDispatch: dispatch.nps
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(chartStyle, { withTheme: 0 })(SimpleLineChart)
  )
);
